// "Sign out everywhere…" in My account (36, Behaviour 4.2, v1.58.7): every circle and the desyr ID on
// every device, this one too, through the admin service; then this device signs out as "Sign out" does.
import { useState } from 'react';
import { Button } from '../blocks/Button';
import { Dialog, DialogButtons, ErrorLine } from '../blocks/Dialog';
import { config } from '../core/config';
import { t } from '../i18n';
import { idCall } from './api';
import { pressed } from './pressed';
import { signOutOfId } from './session';
import { signedOutEverywhere } from './store';

export function SignOutEverywhere() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button small variant="text" onClick={() => setOpen(true)}>
        {t('id.everywhere')}
      </Button>
      {open && <EverywhereDialog onClose={() => setOpen(false)} />}
    </>
  );
}

function EverywhereDialog({ onClose }: { onClose: () => void }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();
  const [done, setDone] = useState<{ desyrId: boolean }>();
  const send = async () => {
    setBusy(true);
    setError(undefined);
    signedOutEverywhere(true);
    try {
      // A press that needs desyr ID (36, Behaviour 1.4): its session over, its sign-in once, back here; pressed again after.
      setDone(await pressed(() => idCall<{ desyrId: boolean }>(config().desyrId!, '/me/sign-out', { method: 'POST' }), () => signedOutEverywhere(false)));
    } catch (e) {
      signedOutEverywhere(false);
      const code = (e as { code?: string }).code;
      setError(t(code === 'desyr.id.unavailable' ? 'id.unavailable' : 'id.everywhereIncomplete'));
    } finally {
      setBusy(false);
    }
  };
  // Afterwards, OK or closing any other way signs this device out (rule 1); its calls may fail silently.
  const finish = () => void signOutOfId(config());
  return (
    <Dialog title={t('id.everywhereTitle')} alert focusFirst onClose={busy ? () => {} : done ? finish : onClose}>
      <p>{t(!done ? 'id.everywhereText' : done.desyrId === false ? 'id.everywherePartly' : 'id.everywhereDone')}</p>
      <ErrorLine>{error}</ErrorLine>
      {done ? (
        <DialogButtons>
          <Button variant="text" onClick={finish}>
            {t('id.ok')}
          </Button>
        </DialogButtons>
      ) : (
      <DialogButtons>
        <Button variant="text" disabled={busy} onClick={onClose}>
          {t('common.cancel')}
        </Button>
        <Button variant="critical-text" busy={busy} onClick={() => void send()}>
          {t('signout.title')}
        </Button>
      </DialogButtons>
      )}
    </Dialog>
  );
}
